"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _reactBootstrap = require("react-bootstrap");

var _close = _interopRequireDefault(require("@parchment/ui-icons/lib/ai/close-1"));

var _createChainedFunction = _interopRequireDefault(require("react-bootstrap/lib/utils/createChainedFunction"));

require("./Modal.less");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// for now just pulling in the react-bootstrap as-is, but if we use this when
// we import modals, then we can apply tweaks as they come up and have them
// apply to all modals using ui-primitive's modal
var BootstrapHeader = _reactBootstrap.Modal.Header;

var Header = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(Header, _React$Component);

  var _super = _createSuper(Header);

  function Header() {
    (0, _classCallCheck2.default)(this, Header);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(Header, [{
    key: "render",
    value: function render() {
      var modal = this.context.$bs_modal;
      return /*#__PURE__*/_react.default.createElement(BootstrapHeader, (0, _extends2.default)({
        className: "primitives-modal-header"
      }, this.props, {
        closeButton: false
      }), this.props.closeButton && /*#__PURE__*/_react.default.createElement("a", {
        className: "modal-header-close-icon",
        href: '#',
        onClick: (0, _createChainedFunction.default)(modal && modal.onHide, this.props.onHide)
      }, /*#__PURE__*/_react.default.createElement(_close.default, null)), this.props.children);
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return BootstrapHeader.propTypes;
    }
  }, {
    key: "defaultProps",
    get: function get() {
      return BootstrapHeader.defaultProps;
    }
  }, {
    key: "contextTypes",
    get: function get() {
      return BootstrapHeader.contextTypes;
    }
  }]);
  return Header;
}(_react.default.Component);

_reactBootstrap.Modal.Header = Header;
var _default = _reactBootstrap.Modal;
exports.default = _default;